module.exports = __webpack_public_path__ + "static/img/address.3758fdf7.png";